import React, { useEffect, useState } from 'react';

import projectsApi from 'Api/projects';

import DeleteBorderButton from 'Components/Buttons/DeleteBorderButton';
import DeleteDialog from 'Components/Dialogs/DeleteDialog';
import { usePortfolioContext } from 'Components/Portfolios/context';

import { isSafetracesAdmin } from 'Config/roles';

import { isTrainingCompanySelected, isValidStatusResponse } from 'Utils';

function DeleteProjectButton({ project }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const { setErrorToast, setSuccessToast, fetchPortfoliosAndSites } =
    usePortfolioContext();

  const canForceDelete = isSafetracesAdmin() && isTrainingCompanySelected();
  const isUsed = !project.status || project.status !== 'new';
  const useForceDelete = isUsed && canForceDelete;

  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);
  const handleOpenDialog = () => {
    setIsOpen(true);
  };
  const handleCloseDialog = () => {
    setIsOpen(false);
  };

  const handleDeleteProject = async () => {
    try {
      if (!isMounted) return;
      setIsLoading(true);
      setSuccessToast('');
      if (!project.projectid) {
        setIsLoading(false);
        setErrorToast('Can not delete project, invalid project ID');
        return;
      }

      const response = useForceDelete
        ? await projectsApi.removeProjectDeep(project.projectid)
        : await projectsApi.removeProjectUpdateTestPackages(project.projectid);

      if (isValidStatusResponse(response)) {
        handleCloseDialog();
        setSuccessToast('Project successfully deleted');
        await fetchPortfoliosAndSites();
      } else {
        setErrorToast(
          response.data?.error?.message ??
            response.data?.error?.detail ??
            'Unexpected error. Site contract was not deleted',
        );
      }
    } catch (e) {
      setErrorToast(e.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <DeleteBorderButton
        clickAction={handleOpenDialog}
        disabled={isUsed && !canForceDelete}
        variant="text"
        tooltipText={
          isUsed ? 'Project is not in status "new".' : 'Delete project'
        }
      />
      <DeleteDialog
        open={isOpen}
        isLoading={isLoading}
        handleClose={handleCloseDialog}
        handleDelete={handleDeleteProject}
        title={isUsed ? 'Force delete the project' : 'Delete project'}
        extraText={
          isUsed && canForceDelete
            ? 'This will delete the project. ' +
              'It will also cancel and delete all samples, and test results associated with the project. ' +
              'This action cannot be undone.'
            : ''
        }
        itemName={project.projectname}
      />
    </>
  );
}

export default DeleteProjectButton;
